<script setup>
    // Vue
    import { useRouter, useRoute } from 'vue-router';
    import { computed, ref } from 'vue';
    //import { useHead } from 'unhead';
    import { getCurrentInstance } from 'vue';
    import { onMounted } from 'vue';
    import { inject } from 'vue';
    import { defineExpose } from 'vue';

    // Component
    import contact from '@/components/modal/ContactComponent.vue';
    import NewsDetail from '@/components/modal/NewsDetailComponent.vue';
    import suerveyApply from '@/components/modal/SuerveyApplyComponent.vue';

    // Store
    //import { useCommonStore } from '@/stores/common/commonStore';
    import { useHeaderStore } from '@/stores/header/headerStore';
    import { useHomeStore } from '@/stores/home/homeStore';
    import { useLanguageStore } from '@/stores/common/languageStore';
    import { useLoginStore } from '@/stores/login/loginStore';
    //import { useTouStore } from '@/stores/common/touStore';

    // Utils
    import Utils from '@/commonProject/helpers/utils.js';

    // Else
    import i18n from '@/common/i18n';

    // 遷移情報
    const route = useRoute();
    const router = useRouter();
    const app = getCurrentInstance();
    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;

    let openUserMenuFlag = ref(false);
    let openSmartPhoneMenuFlg = ref(false);

    const suerveyApplyDispFlg = ref('');
    const suerveyApplyComponent = ref();

    // ログインしたユーザーのベンダーに応じて画面ヘッダー部の表現を制御する。
    // 1：通常ヘッダー
    // 2：TMS用ヘッダー
    const headerType = ref(1);

    // お知らせ詳細モーダル
    const newsDetailDispFlg = ref('');
    const newsDetailComponent = ref();

    // ----------------------------
    // 連絡モーダル
    // ----------------------------
    const contactDisplayFlag = ref('');
    const contactComponent = ref();
    function contactOpen() {
        contactDisplayFlag.value = 'block';
        contactComponent.value.openModal(API_URL);
        document.body.classList.add('modal-open'); //スクロール停止
    }
    async function contactClose() {
        // 事務連絡モーダルを閉じる。
        contactDisplayFlag.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開

        // 新着の連絡を取得する。
        await getNewcontact();
    }

    // ----------------------------
    // 言語切替
    // ----------------------------
    const LANGUAGE_JA = 'ja';
    const LANGUAGE_EN = 'en';
    //const LOGIN_PATH_NAME = 'login';
    const languageStore = useLanguageStore();
    // ローカルストレージに英語で言語情報が登録されている場合はロケールを英語に変更
    if (languageStore.language === LANGUAGE_EN) {
        i18n.global.locale = LANGUAGE_EN;
    }

    const headerStore = useHeaderStore();
    const loginStore = useLoginStore();
    //const commonStore = useCommonStore();
    const homeStore = useHomeStore();
    //const touStore = useTouStore();

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // ----------------------------
    // ログイン後に表示するエリア判定(算術プロパティ)
    // ----------------------------
    const afterLoginDisplay = computed(() => {
        // ヘッダー部の各画面遷移エリアはログイン後に表示する。
        // 以下の画面のみ表示しない。
        switch (route.name) {
            // 表示しない画面の一覧。
            case 'login':
            case 'signinMfa':
            case 'setupPasswordApply':
            case 'setupPasswordComplete':
            case 'signinResetApply':
            case 'signinResetPassword':
            case 'signinResetComplete':
            case 'signinUseridApply':
            case 'signinUseridComplete':
            case 'signupApply':
            case 'signupAgree':
            case 'signupConfirm':
            case 'signupComplete':
            case 'setupCompany':
            case 'setupAgree':
            case 'setupUser':
            case 'setupParent':
            case 'maintenance':
            case 'error':
            case 'pageNotFound':
            case 'login2':
            case 'login3':
                return false;
            default:
                return true;
        }
    });

    // メンテナンス画面などで、言語メニューの表示・非表示を制御するフラグ。
    const noLanguageMenu = computed(() => {
        // 言語メニューの表示・非表示を制御するフラグ。
        // 以下の画面のみ表示しない。
        switch (route.name) {
            // 表示しない画面の一覧。
            case 'maintenance':
                // メンテナンス画面
                return true;
            default:
                return false;
        }
    });

    // ----------------------------
    // 日本語の場合(算術プロパティ)
    // ----------------------------
    const jaLangActive = computed(() => {
        if (languageStore.language === LANGUAGE_JA) {
            return true;
        } else {
            return false;
        }
    });

    // ----------------------------
    // 英語の場合(算術プロパティ)
    // ----------------------------
    const enLangActive = computed(() => {
        if (languageStore.language === LANGUAGE_EN) {
            return true;
        } else {
            return false;
        }
    });

    /**
     * ログアウト
     */
    async function logout() {
        // ログアウト処理を実行する。
        await headerStore.logoutAction();
    }

    /**
     * 言語切替処理
     * @param langType ja:日本語、en:英語
     */
    function changeLang(langType) {
        i18n.global.locale = langType;
        //document.title = i18n.global.t('header.parts.title');
        languageStore.language = langType;

        // 言語が切り替わったので、画面の再描画を行う。
        // ログイン画面は、言語切り替え時にAPIの再読み込みは行わない。
        if (route.name !== 'login') {
            router.go({ name: route.name, force: true });
        }
    }

    async function openUserMenu() {
        if (openUserMenuFlag.value) {
            openUserMenuFlag.value = false;
        } else {
            openUserMenuFlag.value = true;
        }
    }

    async function openSmartPhoneMenu() {
        openSmartPhoneMenuFlg.value = true;
    }

    async function closeSmartPhoneMenu() {
        openSmartPhoneMenuFlg.value = false;
    }

    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(async () => {
        let vendorId = '1';
        if (!Utils.isNullEmpty(route.query.vid)) {
            // ベンダーIDをloginStoreに代入する。
            vendorId = route.query.vid;
        } else {
            switch (true) {
                case loginStore.getVendorId === '2' || loginStore.getVendorId === 't2':
                    {
                        // TMSのベンダーかどうか判定する。
                        vendorId = '2';
                    }
                    break;

                default:
                    {
                        // ARMのベンダーかどうか判定する。
                        vendorId = '1';
                    }
                    break;
            }
        }

        // ログインしたユーザーのベンダーに応じてヘッダー部を変更する。
        switch (true) {
            case vendorId === '2' || vendorId === 't2':
                {
                    // TMSのベンダーかどうか判定する。
                    headerType.value = 2;
                }
                break;

            default:
                {
                    headerType.value = 1;
                }
                break;
        }

        // ログインしたユーザーのベンダーに応じてヘッダー部を再構成する。
        switch (headerType.value) {
            case 1:
                {
                    // ログインしたユーザーがARMの場合。

                    // 現在のベンダーIDのヘッダーを削除する。

                    // ARMのヘッダー。
                    const element1 = document.getElementById('PageStyleSheet1');
                    if (!Utils.isNullEmpty(element1)) {
                        element1.remove();
                    }

                    // TMSのヘッダー。
                    const element2 = document.getElementById('PageStyleSheet2');
                    if (!Utils.isNullEmpty(element2)) {
                        element2.remove();
                    }

                    // ARMのヘッダーを生成する。
                    const head = document.head;
                    head.insertAdjacentHTML('beforeEnd', '<link id="PageStyleSheet1" rel="stylesheet" href="/css/common_client_t1.css" media="all">');
                }
                break;
            case 2:
                {
                    // ログインしたユーザーがTMSの場合。

                    // 現在のベンダーIDのヘッダーを削除する。

                    // ARMのヘッダー。
                    const element1 = document.getElementById('PageStyleSheet1');
                    if (!Utils.isNullEmpty(element1)) {
                        element1.remove();
                    }

                    // TMSのヘッダー。
                    const element2 = document.getElementById('PageStyleSheet2');
                    if (!Utils.isNullEmpty(element2)) {
                        element2.remove();
                    }

                    // TMSのヘッダーを生成する。
                    const head = document.head;
                    head.insertAdjacentHTML('beforeEnd', '<link id="PageStyleSheet2" rel="stylesheet" href="/css/common_client_t2.css" media="all">');
                }
                break;

            default:
                {
                    // ログインしたユーザーが上記以外の場合。

                    // 現在のベンダーIDのヘッダーを削除する。

                    // ARMのヘッダー。
                    const element1 = document.getElementById('PageStyleSheet1');
                    if (!Utils.isNullEmpty(element1)) {
                        element1.remove();
                    }

                    // TMSのヘッダー。
                    const element2 = document.getElementById('PageStyleSheet2');
                    if (!Utils.isNullEmpty(element2)) {
                        element2.remove();
                    }
                }
                break;
        }

        // ログイン済みの場合は、新着情報を確認する。
        if (afterLoginDisplay.value) {
            // 新着の連絡を取得する。
            await getNewcontact();
        }
    });

    /**
     * 新着の連絡を確認する。
     */
    async function getNewcontact() {
        homeStore.EmphasisContact = false;

        // 新着情報確認APIのクエリパラメーターを生成する。
        const queryParam = { FuncNm: 'Contact' };

        // 新着情報確認APIをコールする。
        const response = await homeStore.getArchiveCheckAction(API_URL, queryParam);

        if (response.success) {
            // ヘッダー部の事務連絡の新着アイコンを制御する。
            homeStore.EmphasisContact = response.responseBody.Result;
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    /**
     * スマートフォンヘッダーモードの「お知らせ」エリアから、
     * お知らせモーダルを開くイベント処理。
     * @param noticeType
     * @param noticeBulletinPk
     * @param noticeHistPk
     * @param noticeReaded
     * @param index クリックしたお知らせの座標。何番目のお知らせかを継承して、お知らせモーダル側のページング座標を制御する。
     */
    async function newsDetailOpenFromSmartPhoneHeader(noticeType, noticeBulletinPk, noticeHistPk, noticeReaded, index) {
        newsDetailComponent.value.newsDetailSet(API_URL, noticeType, noticeBulletinPk, noticeHistPk, noticeReaded, index);
        newsDetailDispFlg.value = 'block';
    }

    /**
     * PCヘッダーモードの「お知らせ」エリアから、
     * お知らせモーダルを開くイベント処理。
     * @param noticeType
     * @param noticeBulletinPk
     * @param noticeHistPk
     * @param noticeReaded
     * @param index クリックしたお知らせの座標。何番目のお知らせかを継承して、お知らせモーダル側のページング座標を制御する。
     */
    async function openNewsDetailModalFromHomePage(noticeType, noticeBulletinPk, noticeHistPk, noticeReaded, index) {
        newsDetailComponent.value.newsDetailSet(API_URL, noticeType, noticeBulletinPk, noticeHistPk, noticeReaded, index);
        newsDetailDispFlg.value = 'block';
    }

    /**
     * お知らせモーダルを閉じる。
     */
    async function newsDetailClose() {
        // お知らせモーダルを閉じる。
        newsDetailDispFlg.value = '';

        // 現在表示中のお知らせの一覧を初期化する。
        homeStore.List = [];

        const queryParam = { Lang: languageStore.getLanguageValue };
        const response = await homeStore.getNewsListAction(API_URL, queryParam);
        if (!response.success) {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    async function closeNewsDetailAndOpenContactModal() {
        newsDetailDispFlg.value = '';
        document.getElementById('contactModal').click();
    }

    /**
     * お知らせ詳細モーダルのアンケート回答ボタンをクリックし、アンケートモーダルを表示する。
     * @param questionaryPk お知らせ詳細モーダルのアンケート回答ボタンをクリックした際に取得したアンケートPK
     */
    async function closeNewsDetailModalAndOpenSuerveyApllyModalFrom(questionaryPk) {
        if (!Utils.isNullEmpty(questionaryPk)) {
            // お知らせ詳細モーダルを閉じる。
            newsDetailDispFlg.value = '';

            // アンケートモーダルを表示する。
            suerveyApplyDispFlg.value = 'block';
            suerveyApplyComponent.value.openModal(API_URL, languageStore.getLanguageValue, null, null, questionaryPk);
            document.body.classList.add('modal-open'); //スクロール停止
        }
    }

    /**
     * お知らせ詳細モーダルのアンケート回答ボタンをクリックして表示したアンケートモーダルを閉じる。
     */
    function suerveyApplyClose() {
        suerveyApplyDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
        // 画面をリフレッシュする。
    }

    /**
     * お知らせ詳細モーダルのアンケート回答ボタンをクリックして表示したアンケートモーダルでのアンケートの登録が完了したので、アンケートモーダルを閉じて、ホーム画面の表示に戻す。
     */
    async function updateReserveDetailFromSuerveyApply() {
        // アンケート画面を閉じる。
        suerveyApplyDispFlg.value = '';
    }

    defineExpose({
        openNewsDetailModalFromHomePage,
    });
</script>

<style></style>

<template>
    <template v-if="afterLoginDisplay">
        <!--ログイン後のヘッダー部-->
        <section id="smartPhoneOverlay" :class="{ open: openSmartPhoneMenuFlg }">
            <article id="smartPhoneMenuClose" @click="closeSmartPhoneMenu" />
            <article id="smartPhoneMenuBody">
                <ul id="spUserInfo">
                    <li class="user">
                        <span class="userName">{{ loginStore.getUserName }}</span>
                    </li>
                    <li class="language">
                        <ul>
                            <li>
                                <!--日本語-->
                                <button type="button" :class="{ selected: jaLangActive }" @click="changeLang(LANGUAGE_JA)">{{ $t('header.parts.languageJp') }}</button>
                            </li>
                            <li>
                                <!--英語-->
                                <button type="button" :class="{ selected: enLangActive }" @click="changeLang(LANGUAGE_EN)">{{ $t('header.parts.languageEn') }}</button>
                            </li>
                        </ul>
                    </li>
                </ul>
                <div class="menu">
                    <ul>
                        <li>
                            <!--メニュー-->
                            <router-link :to="{ path: '/home' }" class="btnText">{{ $t('header.parts.button3') }}</router-link>
                        </li>
                        <li>
                            <!--ご予約の確認-->
                            <router-link :to="{ path: '/reserve/list' }" class="btnText">{{ $t('header.parts.button1') }}</router-link>
                        </li>
                        <li :class="{ emphasis: homeStore.EmphasisContact }">
                            <!--事務連絡-->
                            <button type="button" class="btnText" @click="contactOpen" id="contactModal">{{ $t('header.parts.button2') }}</button>
                        </li>
                        <template v-for="menu in homeStore.Menu2" :key="menu.index">
                            <li>
                                <template v-if="menu.Destination !== null && menu.Destination.indexOf('/file/download') !== -1">
                                    <!--ファイルダウンロード-->
                                    <router-link :to="{ path: menu.Destination }" class="btnText">{{ menu.Caption }}</router-link>
                                </template>
                                <template v-else>
                                    <!--外部へのリンクが設定されている場合-->
                                    <a :href="menu.Destination" v-html="menu.Caption" class="btnText" target="_blank" />
                                </template>
                            </li>
                        </template>
                        <li>
                            <!--ユーザー情報-->
                            <router-link :to="{ path: '/user/detail' }" class="btnText" id="userInfo">{{ $t('header.parts.userInfo') }}</router-link>
                        </li>
                        <li>
                            <!--ログアウト-->
                            <button type="button" class="btnText" @click="logout">{{ $t('header.parts.logout') }}</button>
                        </li>
                    </ul>
                </div>
                <div class="news">
                    <!--お知らせ-->
                    <h2 class="newsTitle">{{ $t('home.parts.blockTitle1') }}</h2>
                    <ul class="newsArea">
                        <template v-for="(news, index) in homeStore.List" :key="news.index">
                            <li :class="{ unread: !news.NoticeReaded }">
                                <button type="button" @click="newsDetailOpenFromSmartPhoneHeader(news.NoticeType, news.NoticeBulletinPk, news.NoticeHistPk, news.NoticeReaded, index)">
                                    <span class="date">{{ news.NoticeDt }}</span>
                                    <span class="title">{{ news.NoticeSubject }}</span>
                                </button>
                            </li>
                        </template>
                    </ul>
                </div>
            </article>
        </section>
        <!--スマートフォンのヘッダー部-->
        <section id="overlay" :style="{ display: contactDisplayFlag }">
            <contact ref="contactComponent" @contactModal:cancel="contactClose" />
        </section>
        <!--事務連絡（お知らせ）モーダル-->
        <section id="overlay" :style="{ display: newsDetailDispFlg }">
            <NewsDetail ref="newsDetailComponent" @newsDetailModal:close="newsDetailClose" @newsDetailModal:openContactModalFromNewDetailModal="closeNewsDetailAndOpenContactModal" @newsDetailModal:openSuerveyApllyModalFromNewsDetailModal="closeNewsDetailModalAndOpenSuerveyApllyModalFrom" />
        </section>
        <!--お知らせ-->
        <section id="overlay" :style="{ display: suerveyApplyDispFlg }">
            <suerveyApply ref="suerveyApplyComponent" @suerveyApplyModal:close="suerveyApplyClose" @suerveyApplyModal:update="updateReserveDetailFromSuerveyApply" />
        </section>
        <!--アンケートモーダル関連-->
        <header>
            <ul>
                <li id="title">
                    <template v-if="headerType === 1">
                        <!--通常のヘッダー-->
                        <h1>&nbsp;</h1>
                    </template>
                    <template v-else-if="headerType === 2">
                        <!--TMSのヘッダー-->
                        <h1>{{ $t('header.parts.titleTms') }}</h1>
                    </template>
                </li>
                <li id="headerLinks">
                    <ul>
                        <li>
                            <!--メニュー-->
                            <router-link :to="{ path: '/home' }" class="btnText">{{ $t('header.parts.button3') }}</router-link>
                        </li>
                        <li>
                            <!--ご予約の確認-->
                            <router-link :to="{ path: '/reserve/list' }" class="btnText">{{ $t('header.parts.button1') }}</router-link>
                        </li>
                        <li :class="{ emphasis: homeStore.EmphasisContact }">
                            <!--事務連絡-->
                            <button type="button" class="btnText" @click="contactOpen" id="contactModal">{{ $t('header.parts.button2') }}</button>
                        </li>
                    </ul>
                </li>
                <li :class="{ user: true, open: openUserMenuFlag }" @click="openUserMenu">
                    <span class="userName">{{ loginStore.getUserName }}</span>
                    <ul class="userMenu">
                        <li>
                            <!--ユーザー情報-->
                            <router-link :to="{ path: '/user/detail' }" class="btnText" id="userInfo">{{ $t('header.parts.userInfo') }}</router-link>
                        </li>
                        <li>
                            <!--ログアウト-->
                            <button type="button" class="btnText" id="btnLogout" @click="logout">{{ $t('header.parts.logout') }}</button>
                        </li>
                    </ul>
                </li>
                <li class="language">
                    <ul>
                        <li>
                            <!--日本語-->
                            <button type="button" :class="{ selected: jaLangActive }" @click="changeLang(LANGUAGE_JA)">{{ $t('header.parts.languageJp') }}</button>
                        </li>
                        <li>
                            <!--英語-->
                            <button type="button" :class="{ selected: enLangActive }" @click="changeLang(LANGUAGE_EN)">{{ $t('header.parts.languageEn') }}</button>
                        </li>
                    </ul>
                </li>
                <li id="smartPhoneMenu">
                    <!--ハンバーガーメニュー-->
                    <button type="button" @click="openSmartPhoneMenu">&nbsp;</button>
                </li>
            </ul>
        </header>
    </template>
    <template v-else>
        <!--ヘッダー部（ログイン前）-->
        <section id="smartPhoneOverlay" :class="{ open: openSmartPhoneMenuFlg }">
            <article id="smartPhoneMenuClose" @click="closeSmartPhoneMenu" />
            <article id="smartPhoneMenuBody">
                <ul id="spUserInfo">
                    <template v-if="!noLanguageMenu">
                        <!--言語メニュー-->
                        <li class="language">
                            <ul>
                                <li>
                                    <!--日本語-->
                                    <button type="button" :class="{ selected: jaLangActive }" @click="changeLang(LANGUAGE_JA)">{{ $t('header.parts.languageJp') }}</button>
                                </li>
                                <li>
                                    <!--英語-->
                                    <button type="button" :class="{ selected: enLangActive }" @click="changeLang(LANGUAGE_EN)">{{ $t('header.parts.languageEn') }}</button>
                                </li>
                            </ul>
                        </li>
                    </template>
                </ul>
            </article>
        </section>
        <header>
            <ul>
                <li id="title">
                    <template v-if="headerType === 1">
                        <!--通常のヘッダー-->
                        <h1>&nbsp;</h1>
                    </template>
                    <template v-else-if="headerType === 2">
                        <!--TMSのヘッダー-->
                        <h1>{{ $t('header.parts.titleTms') }}</h1>
                    </template>
                </li>
                <template v-if="!noLanguageMenu">
                    <!--言語メニュー-->
                    <li class="language">
                        <ul>
                            <li>
                                <!--日本語-->
                                <button type="button" :class="{ selected: jaLangActive }" @click="changeLang(LANGUAGE_JA)">{{ $t('header.parts.languageJp') }}</button>
                            </li>
                            <li>
                                <!--英語-->
                                <button type="button" :class="{ selected: enLangActive }" @click="changeLang(LANGUAGE_EN)">{{ $t('header.parts.languageEn') }}</button>
                            </li>
                        </ul>
                    </li>
                </template>
                <li id="smartPhoneMenu">
                    <!--ハンバーガーメニュー-->
                    <button type="button" @click="openSmartPhoneMenu">&nbsp;</button>
                </li>
            </ul>
        </header>
    </template>
</template>
